import React from "react";
import { ASSETS } from "../../utils/config";

export default function UserImage({ image, size = 45, style, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        backgroundImage: `url(${ASSETS.backgroundWheelProfile})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: size * 0.1,
        ...style,
      }}
    >
      <img
        alt="us"
        src={image ? image : ASSETS.userPlaceholder}
        style={{
          width: "100%",
          height: "100%",
          border: "1px solid white",
          borderRadius: "50%",
          backgroundColor: "white",
        }}
      />
    </div>
  );
}
